import makeStyles from '@mui/styles/makeStyles';

const styles = makeStyles(() => ({
  container: {
    position: "relative",
    paddingBottom: "40px",
  },
  maintenanceContainer: {
    position: "relative",
    minHeight: "calc(100vh - 300px)",
    paddingBottom: "40px",
  },
  compactContainer: {
    position: "relative",
    paddingBottom: 0,
  },
  none: {
    display: "none",
  },
  titleDescription: {
    fontWeight: "bold",
    color: "rgb(10,55,99)",
  },
  description: {
    color: "rgb(10,55,99)",
  },
  headerButtons: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: "25px",
    fontSize: "12px",
    textAlign: "center",
    cursor: "pointer",
    border: "1px solid rgba(0, 0, 0, .3)",
    borderRadius: "3px",
  },
  buttonTab: {
    backgroundColor: "white",
    border: "none",
    width: "100px",
    height: "100%",
    cursor: "pointer",
    "&:nth-child(1)": {
      borderRight: "1px solid rgba(0, 0, 0, .3)",
    },
  },
  buttonTabSelected: {
    backgroundColor: "rgba(0,0,0,.05)",
    cursor: "pointer",
    border: "none",
    width: "100px",
    height: "100%",
  },
  addButton: {
    cursor: "pointer",
    fontSize: "13px",
    marginRight: "5px",
    color: "white",
    backgroundColor: "rgb(0, 158, 15)",
    border: "none",
    borderRadius: "3px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "0px 5px",
    "&:hover": {
      backgroundColor: "rgb(0, 158, 15)",
    },
  },
  inputSearchContainer: {
    padding: "1px 0px",
    border: "1px solid rgba(0, 0, 0, .4)",
    display: "flex",
    alignItems: "center",
  },
  inputSearch: {
    border: "none",
  },
  badgeCondition: {
    backgroundColor: "rgb(92,180,75)",
    borderRadius: "50%",
    color: "white",
    width: "min-content",
    padding: "4px 6px",
    margin: "auto",
    fontSize: "10px",
    fontWeight: "bold",
  },
  badgeStatus: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "12px",
  },
  badgePhotos: {
    position: "relative",
    top: "12px",
    left: "10px",
    backgroundColor: "rgb(92,180,75)",
    borderRadius: "50%",
    color: "white",
    width: "min-content",
    padding: "2px 4px",
    margin: "auto",
    fontSize: "9px",
    fontWeight: "bold",
  },
  MEContainer: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
  },
  MEBadge: {
    height: "10px",
    width: "10px",
    borderRadius: "50%",
    backgroundColor: "#174176",
    marginRight: "5px",
    cursor: "default",
  },
  changeStatusButton: {
    cursor: "pointer",
    fontSize: "13px",
    marginRight: "5px",
    color: "white",
    backgroundColor: "#174176",
    borderRadius: "3px",
    border: "1px solid #333",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "3px 10px",
  },

  "orders-inventory-tabs": {
    ".ui.menu": {
      border: "none",
      boxShadow: "none",
      minHeight: "25px",
      a: {
        padding: " 1px 15px",
        font: "12px Heebo, sans-serif",
        color: "#000",
        borderTop: "1px #b3b3b3 solid",
        borderBottom: "1px #b3b3b3 solid",
        borderLeft: "1px #b3b3b3 solid",

        "&:first-of-type": {
          "border-top-left-radius": "3px",
          "border-bottom-left-radius": "3px",
        },

        "&:last-of-type": {
          "border-top-right-radius": "3px",
          "border-bottom-right-radius": "3px",
          borderRight: "1px #b3b3b3 solid",
        },
      },
    },
  },
  headerTitle: {
    fontSize: "20px",
    fontFamily: "Manrope",
    fontWeight: 600,
    lineHeight: "24px",
    marginRight: "15px",
    color: "#465869",
  },
  header: {
    marginBottom: "15px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  actualInventoryWrapper: {
    "& .top-panel": {
      alignItems: "flex-start",
      "& .left-side": {
        alignItems: "flex-start",
        "& .children-container": {
          alignSelf: "flex-start",
          alignItems: "flex-start",
        },
      },
      "& .search-container": {
        "& .search-input": {
          "& .input-container": {
            height: "38px",
            "& .search-icon-container": {
              height: "37px",
            },
          },
        },
      },
    },
  },
  paragraphTable: {
    fontSize: "14px",
    lineHeight: "21px",
    color: "#465869",
    marginBottom: "0",
    "& .measurement": {
      color: "#9CA6AF",
      fontWeight: "bold",
      marginLeft: "5px",
    },
  },
  spanParagraphTable: {
    fontSize: "18px",
    fontWeight: "bold",
    lineHeight: "27px",
    color: "#20639D",
    marginLeft: "5px",
  },
  buttons: {
    position: "absolute",
    bottom: 0,
    right: 0,
  },
}));

export default styles;
